import React, {Component} from 'react';
import {
    StyleSheet,
    TouchableOpacity,
    Image,
    ScrollView,
    View, FlatList, Platform, Animated, KeyboardAvoidingView, Linking, Alert, TouchableHighlight
} from 'react-native';
import HMTextView from "../../../../customviews/HMTextView";
import HMButton from "../../../../customviews/HMButton";
import Colors, {colorPrimary} from "../../../../tools/Colors";
import {moderateScale, verticalScale} from "../../../../tools/Scaling";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";

import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import i18n from "../../../../I18n/i18n";
import HMListSelect from "../../../../customviews/HMListSelect";
import {typeExport} from "../../../../redux/store/type";
import PathFile from "../../../../assets/PathFile";
import HMAlert from "../../../../customviews/HMAlert";
import {ToggleSwitch} from "../../../../customviews/switch";
import * as NavigationService from "../../../../redux/NavigationService";
import store from "../../../../redux/store";
import axios from "axios";
import {serviceActionPending} from "./action/ActionPaySatiaScreen";


let didBlurSubscription = null;
let didwillFocusSubscription = null;

let container = null;
let checkScreenRegister = null;
let Phone = null;
export default class PaySatiaScreen extends Component {
    constructor(props) {
        super(props);
        //alert("sdfjgh")
        container = this;
        this.props.callserviceActionRefresh();
        let params = props.route && props.route.params;
        checkScreenRegister = params ?
            props.route.params.checkScreenRegister
            :
            props.checkScreenRegister;
        Phone = params ? params.Phone : props.Phone;

        let item = params ? params.item : props.item;
        let customer = this.props.DataSplashSatiaScreen.user ? this.props.DataSplashSatiaScreen.user.customer : null;
        //  let banks = customer ? customer.banks : [];

        let list = [
            {
                title: 'نام',
                description: customer ? customer.FName + " " + customer.LName : null,
            },

            {
                title: 'سرويس انتخابي',
                description: item.Name,
            },
            {
                title: 'قيمت سرويس',
                description: item.Price,
                cammas: true,
                lineThrough: true
            },
            {
                title: 'شماره تلفن',
                description: customer ? customer.Username : (Phone ? Phone : ''),
            },
            {
                title: 'هزینه راه اندازی مخابرات',
                description: item.ranjecost,
                cammas: true
            },
            {
                title: 'هزینه نصب و کانفیگ در محل',
                description: item.nasbcost,
                cammas: true
            },
            {
                title: 'ماليات بر ارزش افزوده',
                description: item.Tax,
                cammas: true
            },
            {
                title: 'آبونمان',
                description: item.Subscription,
                cammas: true
            },
            {
                //title: 'آبونمان ویژه',
                title: item.NameAbonmanSpecial,
                description: item.AbonmanSpecial,
                cammas: true
            },
            {
                title: 'هزینه ارسال پیامک',
                description: item.SmsCost,
                cammas: true
            },
            {
                title: 'تخفیف معرفی به دوستان',
                description: item.DiscountMoaref,
                subDescription: item.DescriptionDiscountMoaref,
                cammas: true,
                type: "discount"
            },
            {
                title: 'اعتبار پنل شما',
                description: (customer ? customer.wallet : '0'),
                cammas: true,
                type: "wallet"
                // description: '2,000,000' +" ریال ",
            },
            {
                title: 'مبلغ قابل پرداخت',
                description: item.SumPrice,
                cammas: true,
                total: true,
                type: 'totalPrice'
            },


        ];

        let items = []
        for (let i = 0; i < list.length; i++) {
            let item = list[i];
            if (item.description == 0 || item.description == null || item.description == undefined) {
            }
            else
                items.push(item)
        }
        list = items;
        // if (item.AbonmanSpecial == 0 || item.AbonmanSpecial == null || item.AbonmanSpecial == undefined)
        //     list.splice(6, 1)

        this.state = {
            minimumPayment: 1000,
            isOnBlueToggleSwitch: props.DataSplashSatiaScreen.wallet > 0 ,
            selectedIndex: 0, //for segmented control
            checked: false,
            //  address: this.props.user.address,
            address: "",
            description: null,
            paymentStatus: 0, //0 not yet -- 1 success  -- 2 failure
            json: {},
            alert: false,
            OneProps: false,
            items: {},
            showDialogDate: false,
            selectedDate: 0,
            Date: 0,
            finalDate: 0,
            wallet: props.DataSplashSatiaScreen ? props.DataSplashSatiaScreen.wallet : 0,

            list: list,
            //  indexSelectCheckBoxPay: banks[0].id ? banks[0].id : banks[0].Serial
            //  // indexSelectCheckBoxPay: 1
            indexSelectCheckBoxPay: customer && customer.banks ? customer.banks[0].Serial : null
        };
        this.onDayPress = this.onDayPress.bind(this);
    }

    componentDidMount() {
        this.getWalletDataServer()
        // didBlurSubscription = this.props.navigation.addListener('blur', () => {
        // })
        // didwillFocusSubscription = this.props.navigation.addListener('focus', () => {
        //     // if (this.props.CartList.length === 0)
        //     //     this.props.navigation.pop()
        // })
        Linking.addEventListener('url', this.handleOpenURL);
        //    this.setState({OneProps: true}, () => this.set_Data())

    }

    componentWillUnmount() {


        //    didBlurSubscription.remove();
        //    didwillFocusSubscription.remove();
        Linking.removeEventListener('url', this.handleOpenURL);
        this.props.callserviceActionRefresh();
        if (this.props.CancelToken) {
            this.props.CancelToken();
        }
    }

    componentWillReceiveProps(propss) {
        /*   let res = 0;
           let {first_buy_discount} = this.props.data_splash.results;
           let Final_amount = first_buy_discount !== null ? ((this.props.PriceAll) - (parseInt((this.props.PriceAll - parseInt(this.props.DiscountAll)) * (first_buy_discount.percent / 100)) + parseInt(this.props.DiscountAll))) : this.props.PriceAll - parseInt(this.props.DiscountAll)

           let {PriceAll} = this.props;

           if (propss.NoInternetDialog) {
               //  this.loadingButton.showLoading(false);
           }
           if (propss.results !== null && this.state.OneProps) {

               this.setState({OneProps: false},
                   () => {
                       //this.loadingButton.showLoading(false);
                       if (propss.results.status === true) {
                           switch (this.state.selectedIndex) {
                               case 0:

                                   break;
                               case 1:
                                   this.props.callserviceClearAllCar();
                                   this.props.callserviceChangeItemDiscount();

                                   this.setState({alert: true})
                                   break;

                               case 2:
                                   this.props.callserviceClearAllCar();
                                   this.props.callserviceChangeItemDiscount();

                                   this.setState({alert: true}, () => {
                                       //res = (first_buy_discount !== null ? (PriceAll - (PriceAll * (first_buy_discount.percent / 100))) : PriceAll)
                                       // res = (first_buy_discount !== null ? ((this.props.PriceAll) - (parseInt((this.props.PriceAll - parseInt(this.props.DiscountAll)) * (first_buy_discount.percent / 100)) + parseInt(this.props.DiscountAll))) : this.props.PriceAll - parseInt(this.props.DiscountAll))
                                       res = Final_amount;
                                       this.props.callserviceSetWallet(res, 0)
                                   })
                                   break;
                           }
                       } else {
                           HMAlert(
                               i18n.t('constant.message'),
                               propss.results.message,
                               [
                                   // {text: 'Ask me later', onPress: () => {}},
                                   // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                   {text: i18n.t('constant.ok'), onPress: () => {}},
                               ],
                               {cancelable: true}
                           )
                           //alert(propss.results.message)
                       }
                   })

           }*/
    }

    handleOpenURL = (event) => {
        this.navigate(event.url);
    }
    navigate = (url) => {
        const route = url.replace(/.*?:\/\//g, '');
        const status = route.match(/\/([^\/]+)\/?$/)[1];
        switch (status) {
            case "success": {
                this.props.navigation.navigate("ListServiceHistorySatiaScreen")

                this.setState({
                    paymentStatus: 1
                });
                global._refreshSplashSatia = true;
                break;
            }
            case "failure": {
                this.setState({paymentStatus: 2});
                break;
            }
            default: {
                this.setState({paymentStatus: 0});
                break;
            }
        }
    }
    // handleIndexChange = (index) => {
    //     this.setState({
    //         selectedIndex: index,
    //     });
    // }

    handleIndexChange(index) {
        this.setState({
            selectedIndex: index,
        });
    }

    handleDateChange() {
        this.setState({
            selectedDate: 0,
            Date: 0

            // showDialogDate:this.state.selectedDate ? false :true
        });
    }

    getWalletDataServer() {
        const formData = new FormData();
        formData.append('token', this.props.token);

        axios(
            {
                url: typeExport._baseUrlSatia + "payments/getWallet",
                method: "post",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    //  "Authorization": token,
                },
                data: formData,
                timeout: typeExport._TIMEOUT,
                //   CancelToken: CancelToken.token
                // cancelToken: new CancelToken(function executor(c) {
                //
                //
                //     // An executor function receives a cancel function as a parameter
                //    // cancel = c;
                // })
            }
        ).then(response => {

            if (response.data.wallet && response.data.wallet >= 0) {
                this.props.callServiceSetWallet(response.data.wallet)

                this.setState({
                    wallet: response.data.wallet,
                    minimumPayment: response.data.minimumPayment ? response.data.minimumPayment : this.state.minimumPayment,
                })
            }

        });

    }

    set_Data() {

        let item = this.props.route.params.item
        this.props.callService(typeExport.urlSetPaySatiaScreen,
            `token=${this.props.DataSplashSatiaScreen.token}&customer=${this.props.DataSplashSatiaScreen.Account ? JSON.stringify(this.props.DataSplashSatiaScreen.Account) : null}&serialService=${item.Serial}&platform=${Platform.OS}&lang=${i18n.locale}&serialBank=${this.state['indexSelectCheckBoxPay']}&checkWallet=${this.state.isOnBlueToggleSwitch}`,
            typeExport.TypeSetDataPaySatiaScreen, 'POST', this.state.selectedIndex, this.props.token)
    }


    renderSuccessPayment() {
        return (<View style={styles.containerHasLoading}>
            <Image style={{width: moderateScale(100), height: moderateScale(100)}}
                   source={PathFile.image.success}/>
            <HMTextView type={"bold"} style={{marginTop: moderateScale(15), fontSize: moderateScale(16)}}
                        text={"کاربر گرامی خرید با موفقیت انجام شد"}/>
            <HMButton text={"سوابق سرویس ها"} style={{marginTop: moderateScale(15)}} textType={"bold"}
                // onPress={() => this.props.navigation.pop()}
                      onPress={() => this.props.navigation.navigate("ListServiceHistorySatiaScreen")}
            />

        </View>);
    }

    renderFailurePayment() {
        return (<View style={styles.containerHasLoading}>
            <Image style={{width: moderateScale(100), height: moderateScale(100)}}
                   source={PathFile.image.error}/>
            <HMTextView type={"bold"} style={{marginTop: moderateScale(15), fontSize: moderateScale(16)}}
                        text={"کاربر گرامی خرید انجام نشد!"}/>
            <HMButton text={i18n.t('constant.Back')} style={{marginTop: moderateScale(15)}} textType={"bold"}
                      onPress={() => this.props.navigation.pop()}/>

        </View>);

    }

    render() {
        let {minimumPayment} = this.state;
        let params = this.props.route && this.props.route.params;
        let DataExtra = params ? this.props.route.params : this.props;
        let itemExtra = params ? DataExtra.item : this.props.item;
        let Discount = itemExtra.Discount;
        let unitValue = this.props.DataSplashSatiaScreen.unitValue ? this.props.DataSplashSatiaScreen.unitValue : 10;
        let unit = this.props.DataSplashSatiaScreen.unit ? this.props.DataSplashSatiaScreen.unit : "تومان";

        let checkLogin = (store.getState().reducerSplashSatiaScreen.token);

        return (

            <View style={styles.container}>
                {
                    params ?
                        <HMActionBarSatia
                            menu={checkLogin}
                            props={this.props} headerVisibility statusBarTransparent text={"پرداخت"}
                            back
                            onBackPress={() => this.props.navigation.pop()}
                        />
                        :
                        null
                }
                {/*    {
                    !params ?
                        <HMTextView
                            // numberOfLines={2}
                            type={"bold"}
                            text={"پیش نمایش فاکتور"}
                            styleRoot={{alignSelf: "center"}}
                            style={[{
                                fontSize: moderateScale(14),

                                color: Colors.blackLight,
                                marginHorizontal: moderateScale(2),
                                //  marginTop: moderateScale(4),
                                //  textAlign: "right",


                            },]}/>
                        :
                        null
                }*/}
                {
                    this.state.paymentStatus === 0 ?
                        (
                            <KeyboardAvoidingView style={{flex: 1}} behavior={"padding"}
                                                  enabled={Platform.OS === "ios"}>

                                <ScrollView>


                                    <View style={{
                                        borderRadius: moderateScale(4),
                                        borderColor: '#d0d8df',
                                        backgroundColor: Colors.white,
                                        borderWidth: moderateScale(1),
                                        overflow: 'hidden',
                                        marginTop: moderateScale(6), marginHorizontal: moderateScale(10),
                                    }}>
                                        <FlatList
                                            style={{}}
                                            // ItemSeparatorComponent={
                                            //     <View style={{
                                            //         width: '100%',
                                            //         height: moderateScale(1),
                                            //         backgroundColor: '#4f4f4f'
                                            //     }}/>
                                            // }
                                            // data={comment === null || !comment ? [] : comment}
                                            //     numColumns={1}
                                            //type => 1=  , 2= , 3= , 4= ,
                                            data={this.state.list}
                                            renderItem={({item, index}) => {

                                                let resultPrice = parseInt(((item.type == "wallet" ? this.state.wallet : item.description) - (this.state.isOnBlueToggleSwitch && item.type == "totalPrice" ? this.state.wallet : 0)) / unitValue);
                                                resultPrice = item.type == "totalPrice" && this.state.isOnBlueToggleSwitch ? ((resultPrice <= minimumPayment ? ("( حداقل پرداختی باید " + minimumPayment + " تومان باشد)    ") + minimumPayment  : resultPrice)) : resultPrice;
                                                return <View
                                                    style={[{
                                                        flex: 1,
                                                        flexWrap: 'wrap',
                                                        flexDirection: 'row',


                                                        backgroundColor: index % 2 === 0 ? Colors.light : Colors.white,
                                                        padding: moderateScale(4),
                                                        paddingVertical: moderateScale(8)
                                                    }]}>
                                                    <HMTextView type={"bold"} text={item.title + " : "} style={{
                                                        color: Colors.blackLight,
                                                        fontSize: moderateScale(12),
                                                        marginEnd: moderateScale(10)
                                                    }}/>
                                                    {
                                                        item.lineThrough ?
                                                            <View style={{flexDirection: 'row'}}>
                                                                <HMTextView
                                                                    // numberOfLines={2}
                                                                    //type={"bold"}
                                                                    cammas={item.cammas}
                                                                    text={(parseInt((item.description / unitValue)) + " " + unit)}
                                                                    style={[{
                                                                        fontSize: moderateScale(14),

                                                                        color: Colors.blackLight,
                                                                        marginHorizontal: moderateScale(2),
                                                                        //  marginTop: moderateScale(4),
                                                                        //  textAlign: "right",


                                                                    }, !Discount || Discount === 0 ? {} : {
                                                                        textDecorationLine: ('line-through'),
                                                                        textDecorationColor: Colors.red,
                                                                    }]}/>

                                                                {
                                                                    !Discount || Discount === 0 ?
                                                                        null
                                                                        :
                                                                        <HMTextView
                                                                            cammas={item.cammas}
                                                                            // numberOfLines={2}
                                                                            //type={"bold"}
                                                                            text={(parseInt(((item.description - Discount) / unitValue)) + " " + unit)}
                                                                            style={{
                                                                                fontSize: moderateScale(14),

                                                                                color: Colors.green,
                                                                                marginHorizontal: moderateScale(2),
                                                                                //  marginTop: moderateScale(4),
                                                                                //  textAlign: "right",
                                                                            }}/>
                                                                }

                                                            </View>
                                                            :
                                                            <View
                                                                style={{
                                                                    flex: 1,
                                                                    flexDirection: 'row',
                                                                    //flexWrap: 'wrap',
                                                                    // flexDirection: 'row',

                                                                    backgroundColor: index % 2 === 0 ? Colors.light : Colors.white,
                                                                    //   padding: moderateScale(4),
                                                                    // paddingVertical:moderateScale(8),

                                                                }}>
                                                                <HMTextView cammas={item.cammas} type={"bold"}
                                                                            text={((item.description && item.cammas) || item.description == 0 ? ((resultPrice <= 0 ? 0 : resultPrice) + (item.cammas ? " " + unit : "")) : (item.description ? item.description : " - "))}
                                                                            style={{
                                                                                color: (this.state.isOnBlueToggleSwitch && item.type == "wallet") || item.type == "discount" ? Colors.red : (item.total ? Colors.green : Colors.gray),
                                                                                fontSize: moderateScale(item.total ? 15 : 14),
                                                                                //marginEnd: moderateScale(10)
                                                                            }}

                                                                            styleRoot={{flex: 1, flexWrap: 'wrap'}}

                                                                />
                                                                {
                                                                    !item.subDescription ?
                                                                        null
                                                                        :
                                                                        <HMTextView
                                                                            cammas={item.cammas}
                                                                            // numberOfLines={2}
                                                                            //type={"bold"}
                                                                            text={` ( ${item.subDescription } )`}
                                                                            style={{
                                                                                fontSize: moderateScale(12),

                                                                                color: Colors.blue,
                                                                                marginHorizontal: moderateScale(2),
                                                                                //  marginTop: moderateScale(4),
                                                                                //  textAlign: "right",
                                                                            }}/>
                                                                }
                                                            </View>
                                                    }

                                                    {
                                                        item.type === "wallet" ?
                                                            <ToggleSwitch
                                                                label="استفاده از اعتبار"
                                                                onColor={"rgb(0, 96, 96)"}
                                                                isOn={this.state.isOnBlueToggleSwitch}
                                                                onToggle={isOnBlueToggleSwitch => {
                                                                    this.setState({isOnBlueToggleSwitch});
                                                                }}
                                                            />
                                                            :
                                                            null
                                                    }


                                                </View>

                                            }}


                                        />
                                    </View>
                                    {checkScreenRegister ?
                                        null
                                        :
                                        <View
                                            style={{
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                marginHorizontal: moderateScale(12),

                                            }}>
                                            <HMTextView type={"bold"} text={"نوع درگاه" + " : "} style={{
                                                color: Colors.blackLight,
                                                fontSize: moderateScale(14),
                                                marginEnd: moderateScale(10)
                                            }}/>
                                            <View
                                                //     style={{flex:1,justifyContent:'center'}}
                                            >
                                                <HMListSelect
                                                    style={{alignSelf: 'center', marginVertical: moderateScale(6),}}
                                                    //data={this.props.DataSplashSatiaScreen.results.listBank}
                                                    data={{
                                                        list:
                                                            this.props.DataSplashSatiaScreen.user && this.props.DataSplashSatiaScreen.user.customer && this.props.DataSplashSatiaScreen.user.customer.banks ? this.props.DataSplashSatiaScreen.user.customer.banks : [],
                                                        //     [
                                                        //     {
                                                        //         id: 1,
                                                        //         name: "سامان",
                                                        //         image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSIPAF_qd4tBEm0qrW50NLcGUT4of2a_qlOgQT6eqzrflr0gWKR&usqp=CAU'
                                                        //     },
                                                        //     {
                                                        //         id: 2,
                                                        //         name: "آپ",
                                                        //         image: 'https://s.cafebazaar.ir/1/icons/com.sibche.aspardproject.app_512x512.png'
                                                        //     },
                                                        //     {
                                                        //         id: 3,
                                                        //         name: "ملت",
                                                        //         image: 'https://www.drupal.org/files/project-images/mellat.jpg'
                                                        //     },
                                                        //
                                                        // ],

                                                        indexSelect: this.state['indexSelectCheckBoxPay'],
                                                        name: 'Pay',

                                                    }}
                                                    onPress={this.onPressSelectCheckBox
                                                    }

                                                />
                                            </View>
                                        </View>
                                    }


                                </ScrollView>
                                {
                                    params ?
                                        <TouchableOpacity
                                            style={{
                                                backgroundColor: Colors.colorPrimary,
                                                width: "96%",
                                                height: moderateScale(40),
                                                marginTop: moderateScale(6),
                                                alignItems: "center",
                                                justifyContent: "center",
                                                //marginHorizontal:moderateScale(10),
                                                alignSelf: "center",
                                                borderRadius: moderateScale(6),
                                                marginBottom: moderateScale(6)
                                                // borderRadius:moderateScale(2)
                                            }}
                                            onPress={() => {
                                                // Tools.GoLink(this.props.results.Url2)
                                                if (checkScreenRegister) {
                                                    DataExtra.funcSetServiceType(itemExtra);
                                                    NavigationService.BackTo(1);
                                                }
                                                else
                                                    this.setState({OneProps: true}, () => this.set_Data())
                                            }}
                                        >
                                            <View
                                                style={{
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}>
                                                <HMTextView type={"bold"}
                                                            text={checkScreenRegister ? "انتخاب بسته" : "پرداخت"}
                                                            style={{
                                                                color: "white",
                                                                fontSize: moderateScale(16),
                                                                marginEnd: moderateScale(10)
                                                            }}/>

                                            </View>
                                        </TouchableOpacity>
                                        :
                                        null
                                }

                            </KeyboardAvoidingView>
                        )
                        :
                        this.state.paymentStatus === 1 ? this.renderSuccessPayment() : this.renderFailurePayment()
                }


                {
                    this.props.NoInternetDialog ?
                        <DialogConnectionCustomize
                            again
                            onPress={() => {
                                // this.loadingButton.showLoading(false),
                                this.props.callserviceActionRefresh()
                            }}
                        />
                        :
                        null
                }

                {
                    this.props.isLoading ?
                        <DialogLoadingCustomize/>
                        : null
                }
            </View>


        );
    }

    onPressSelectCheckBox(item, name, check) {
        container.setState({
                //    ['indexSelectCheckBox' + name]: check ? item.id : item.id
                ['indexSelectCheckBox' + name]: item.id ? item.id : item.Serial
            },
            () => {
            })
    }

    onDayPress(day) {
        this.setState({
                Date: day.dateString,

            }
            , () => {
                //   alert(day.dateString)
                // alert( moment(day.dateString, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD'))
                // ;
            }
        );
    }

    onPressOkDate(data) {
        if (this.state.Date) {
            this.setState({
                    showDialogDate: data,
                    //  finalDate: moment(this.state.Date, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD'),
                    selectedDate: 1
                },
                () => {
                });
        }
        else {
            HMAlert(
                i18n.t('constant.message'),
                "تاریخی را انتخاب نگرده اید!!!",
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )
        }

    }

    onPressCancelDate(data) {
        this.setState({
                showDialogDate: data,
                selectedDate: 0,
                Date: 0,
                finalDate: 0
            },
            () => {
            });
    }

    onPressBackDate() {
        this.setState({
            showDialogDate: false
        })
    }


}
const styles = StyleSheet.create({
    containerEmpty: {
        flex: 1,
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: Colors.backgroundColor,
    },
    container: {
        flex: 1,
        justifyContent: "space-between",
        backgroundColor: Colors.backgroundColor,
    },
    // container: {
    //     flex: 1,
    //     backgroundColor: Colors.backgroundColor
    // },
    containerHasLoading: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: Colors.backgroundColor
    },
    tabTextStyle: {
        fontFamily: typeExport.regularFontName,
        padding: verticalScale(2),

    },
    tabsContainerStyle: {
        marginVertical: moderateScale(6),
        marginHorizontal: moderateScale(10),

    },
    activeTabTextStyle: {
        fontFamily: Platform.OS === "ios" ? typeExport.regularFontName : typeExport.boldFontName,
        fontWeight: Platform.OS === "ios" ? "900" : null,
    },
    calendar: {
        borderTopWidth: 1,
        paddingTop: 5,
        borderBottomWidth: 1,
        borderColor: '#eee',
        // height: moderateScale(350)
    },
});

